const CenterLoader = () => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-black-100 opacity-75 flex flex-col items-center justify-center">
      <div className="animate-spin ease-linear rounded-full border-4 border-t-4 border-green border-t-white h-12 w-12 mb-4"></div>
    </div>
  );
};

export default CenterLoader;
